var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ff7900;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.44,29.09c.57-.01,1.33.01,1.9,0,0,1.07-.9,2.29-1.74,2.54.57,0,1.14,0,1.72-.01v3.52h-6.92v-3.52c.3,0,.6,0,.9-.01.42.03,1.34.02,2.33-.49,1.51-.78,1.67-1.68,1.81-2.03Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.67,28.3h-.02s-10.3-.09-10.3-.09l.05-5.32,10.28.09c2.64,0,4.78-2.15,4.78-4.79s-2.15-4.79-4.79-4.79h-6.86v-5.32h6.86c5.57,0,10.11,4.53,10.11,10.11s-4.53,10.11-10.11,10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.27,28.31h-.02s-10.3-.09-10.3-.09l.05-5.32,10.28.09c2.64,0,4.78-2.15,4.78-4.79s-2.15-4.79-4.79-4.79h-1.6v2.5h-5.32v-7.82h6.92c5.57,0,10.11,4.53,10.11,10.11s-4.53,10.11-10.11,10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.54,28.21h-14.39c-2.56,0-4.64-2.08-4.64-4.64v-8.29c0-4.01,3.27-7.28,7.28-7.28h10.08v13.17h-5.32v-7.85h-4.76c-1.08,0-1.96.88-1.96,1.96v7.62h13.71v5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.08,36.04h-4.92v-5.32h4.92c1.82,0,6.09-1.48,6.09-3.3v-1.77h5.32v1.77c0,4.75-6.66,8.62-11.41,8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.94,36.04h-7.69c-5,0-9.07-4.07-9.07-9.07v-8.76h5.32v8.76c0,2.07,1.69,3.76,3.76,3.76h7.69c2.79,0,5.07-2.27,5.07-5.07h5.32c0,5.73-4.66,10.38-10.38,10.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.17 7.38 90.81 7.38 90.81 5.5 107.17 .07 107.17 7.38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigi);
export default __webpack_public_path__ + "static/media/digi.0a19fba35652036635e1e1b4215e66ad.svg";
export { ForwardRef as ReactComponent };